import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { User } from '../../core/declarations/user.interface';
import { getCurrentUser } from '../../core/states/user-state/user.selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RedirectIfTermsAccepted {
  constructor(
    private userStore: Store<User>,
    private router: Router
  ) {}

  canActivateChild(
    _: ActivatedRouteSnapshot,
    __: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.userStore.select(getCurrentUser).pipe(
      filter(x => x !== null),
      map(user => user as User),
      map(user => {
        if (user.terms_accepted) {
          return this.router.parseUrl('/home');
        } else {
          return true;
        }
      })
    );
  }
}
